import { render } from "./AdminBom.vue?vue&type=template&id=f2bc9b9a"
import script from "./AdminBom.vue?vue&type=script&lang=js"
export * from "./AdminBom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__